import { withStyles } from "@material-ui/core/styles"
import styles from "../../TabStyles";

import { apiUrl } from "../../../../ui-utils/apiConfig";
import { httpRequest } from "../../../../ui-utils/api"
import EditIcon from "@mui/icons-material/Edit"
import SettingsIcon from "@mui/icons-material/Settings"
import { TablePagination } from "@material-ui/core" // added by srini on 16-01-25

import {
  Typography,
  TableContainer,
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Grid,
  Button,
  Modal,
  Box,
  FormControl,
  FormHelperText,
  InputAdornment,
  Select,
  MenuItem,
  createChainedFunction,
  IconButton,
} from "@material-ui/core";
import snackError from "../../../../helpers/snackError"
import { reducerContext } from "../../../../contextApi's/contextApi's"
import { TextField } from "@mui/material";
import { useEffect, useState,useContext } from "react";
import axios from "axios";

const Department = ({ classes }) => {
    const { dispatch } = useContext(reducerContext)
  const [addDepartmentModal, setAddDepartmentModal] = useState(false);
  const [newName, setNewName] = useState("");
  const [errType, setErrType] = useState(0);
  const [errorMsg, setErrorMsg] = useState("");
  const [description, setDescription] = useState("");
  const [sipGroupId, setSipGroupId] = useState(0);
  const [editDepartment, setEditDepartment] = useState(false);
  const [departmentData, setDepartmentData] = useState([]);
  const [uid, setUid] = useState(0);
  // added by srini on 16-01-25
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [page, setPage] = useState(0)

  useEffect(() => {
    (async () => {
        try {
          const res = await httpRequest({
            endPoint: `${apiUrl.departmentList}`,
            method: "get",
            instance: "instanceOne",
          });
         
    
          if (res?.data?.success === true){
            setDepartmentData(res?.data?.result)
          }
          // Dev Srini 25/10/24
          else{
            console.log('Error in Department List API', res)
          }
        } catch (error) {
          console.log('Error in Department List API', error)
        }
      })()
  }, []);

  const editDepartmentModal = (data) => {
    setAddDepartmentModal(true);
    setEditDepartment(true);
    setNewName(data.name);
    setDescription(data.description);
    setSipGroupId(data.sip_group_id);
    setUid(data.uid);
};


const EditDepartment = async () => {

    let isok = 0;
    if (!newName.length && isok === 0) {
      isok = 1;
      setErrType(1);
      setErrorMsg("Enter the name");
    }

    if (!description.length && isok === 0) {
      isok = 2;
      setErrType(2);
      setErrorMsg("Enter the Description");
    }
    
  
    if (!sipGroupId.toString().length && isok === 0) {
      isok = 3;
      setErrType(3)
      setErrorMsg("Enter the sip group id");
    }
    // validation amended Srini 07-01-25
    const hostname = window.location.hostname

  if (hostname === 'crm.bullforce.co') {
    // Production environment
    if (sipGroupId.toString().length != 6 && isok === 0) {
      isok = 3
      setErrType()
      setErrorMsg("Enter valid sip group id")
    }
  } else if (hostname.includes("staging") || hostname === 'localhost') {
    // Staging environment or localhost
    if (sipGroupId.toString().length != 5 && isok === 0) {
      isok = 3
      setErrType(3)
      setErrorMsg("Enter valid sip group id")
    }
  }

    if(isok === 0){
  
    let newdepartment = {
      name: newName,
      description: description,
      sip_group_id: parseInt(sipGroupId),
      uid: uid,
    };

    try {
      const editdepartmentdata = await httpRequest({
        endPoint: `${apiUrl.departmentEdit}`,
        method: "put",
        instance: "instanceOne",
        requestBody: newdepartment,
      })
      console.log("1",editdepartmentdata?.data)

      if (editdepartmentdata?.data?.success === true) {
        console.log("2", editdepartmentdata?.data?.result.uid)
        const editedDepartmentUid = editdepartmentdata?.data?.result.uid
        const updatedDepartmentData = departmentData.map((department) => {
          if (department.uid === editedDepartmentUid) {
            return editdepartmentdata?.data?.result;
          }
          return department;
        });

        setDepartmentData(updatedDepartmentData);
        setAddDepartmentModal(false);
        setEditDepartment(false);
        setNewName("");
        setDescription("");
        setSipGroupId("");
         dispatch({
                        type: 'SET_SHOW_ERROR',
                        payload: true
                      })
        
                      dispatch({
                        type: 'SET_ERROR',
                        payload: 'Department Edit Success.'
                      })
                    dispatch({ type: 'SET_MY_SNACK', payload: snackError.mySucc })
      }
      else{
        console.log('Error in Department Edit API', editdepartmentdata)

          dispatch({
                        type: 'SET_SHOW_ERROR',
                        payload: true
                      })
        
                      dispatch({
                        type: 'SET_ERROR',
                        payload: 'Error in Department Edit.'
                      })
        
                      dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
      }
    } catch (error) {
      console.log('Error in Department Edit API', error)
    }
}
  };

  const handleCloseModal = () => {
    setAddDepartmentModal(false);
    setEditDepartment(false);
    setNewName("");
    setDescription("");
    setSipGroupId("");
    setErrorMsg("")
  };


  const CreateNewDepartment = async () => {
    let isok = 0;

    if (!newName.length && isok === 0) {
      isok = 1;
      setErrType(1);
      setErrorMsg("Enter the name");
    }

    if (!description.length && isok === 0) {
      isok = 2;
      setErrType(2);
      setErrorMsg("Enter the Description");
    }
    if (!sipGroupId.length && isok === 0) {
      isok = 3;
      setErrType(3);
      setErrorMsg("Enter the sip group id");
    }
    if (sipGroupId.length != 6 && isok === 0) {
      isok = 3;
      setErrType(3);
      setErrorMsg("Enter Valid sip group id");
    }

    if (isok === 0) {
      let newdepartment = {
        name: newName,
        description: description,
        sip_group_id: parseInt(sipGroupId),
      };

      try {
        const newdepartmentdata = await httpRequest({
          endPoint: `${apiUrl.departmentCreate}`,
          method: "post",
          instance: "instanceOne",
          requestBody: newdepartment,
        });
        console.log(newdepartmentdata?.data)

        if (newdepartmentdata?.data?.success === true) {
          setNewName("");
          setDescription("");
          setSipGroupId("");
          setDepartmentData([...departmentData , newdepartmentdata?.data?.result])
          setAddDepartmentModal(false) 

           dispatch({
                          type: 'SET_SHOW_ERROR',
                          payload: true
                        })
          
                        dispatch({
                          type: 'SET_ERROR',
                          payload: 'Department created Successfully.'
                        })
                      dispatch({ type: 'SET_MY_SNACK', payload: snackError.mySucc })
        }
        else{
          console.log('Error in Department Create API', newdepartmentdata)

      
                    dispatch({
                      type: 'SET_SHOW_ERROR',
                      payload: true
                    })

                    dispatch({
                      type: 'SET_ERROR',
                      payload: 'Error in department create.'
                    })

                    dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
        }
      } catch (error) {
        console.log('Error in Department Create API', error)
          dispatch({
                      type: 'SET_SHOW_ERROR',
                      payload: true
                    })

                    dispatch({
                      type: 'SET_ERROR',
                      payload: 'Error in department create.'
                    })

                    dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
      }
    }
  };

  // added by srini on 16-01-25
  const handlePageChange = (event, newpage) => {
    setPage(newpage)
  }
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  return (
    <div style={{ flex: '82%', marginLeft: '2%',height:"100vh" }}>
      <Typography
        className={classes.dashboardText2}
        style={{ color: "#FFFFFF", marginTop: "8%", }}
      >
        Department
      </Typography>
      <Button
        style={{
          width: "172px",
          height: "20px",
          border: "2px solid red",
          margin: '1% 0 1% 80%'
        }}
        onClick={() => setAddDepartmentModal(true)}
      >
        <span className={classes.addUserText} style={{ textTransform: "none" }}>
          Add New Department{" "}
        </span>
      </Button>

      <Modal
        className={classes.modalCard2}
        open={addDepartmentModal}
        style={{ marginLeft: "500px", marginTop: "190px" }}
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0)",
          },
        }}
      >
        <div>
          <img
            src={require("../../../../ui-assets/XFrame.png")}
            alt=" X Icon"
            onClick={() => handleCloseModal()}
            style={{
              width: "24px",
              height: "24px",
              flexShrink: "0",
              marginLeft: "495px",
              marginTop: "23px",
              cursor: "pointer",
            }}
          />
          <Grid Container style={{ marginLeft: "100px", marginTop: "10px" }}>
            <Grid item>
              <Typography
                className={classes.formlabel1}
                style={{ paddingTop: "10px" }}
              >
                Name
              </Typography>
              <FormControl>
                <TextField
                  value={newName}
                  placeholder="Enter name"
                  InputProps={{
                    style: {
                      width: "342px ",
                      height: "42px ",
                      backgroundColor: "white",
                      flexShrink: 0,
                      color: "black",
                      fontFamily: "cardiuma-regular",
                      fontSize: "12px",
                      fontStyle: "normal",
                      fontWeight: "400",
                      lineHeight: "20px",
                    },
                  }}
                  onChange={(e) => {
                    setNewName(e.target.value);
                    setErrType(0);
                  }}
                />
                {errType === 1 && (
                  <FormHelperText
                    className={classes.errtxt}
                    id="component-error-text"
                  >
                    {errorMsg}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>

            <Grid item>
              <Typography
                className={classes.formlabel1}
                style={{ paddingTop: "10px" }}
              >
                Description
              </Typography>
              <FormControl>
                <TextField
                  value={description}
                  placeholder="Enter Description"
                  InputProps={{
                    style: {
                      width: "342px ",
                      height: "42px ",
                      backgroundColor: "white",
                      flexShrink: 0,
                      color: "black",
                      fontFamily: "cardiuma-regular",
                      fontSize: "12px",
                      fontStyle: "normal",
                      fontWeight: "400",
                      lineHeight: "20px",
                    },
                  }}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    setErrType(0);
                  }}
                />
                {errType === 2 && (
                  <FormHelperText
                    className={classes.errtxt}
                    id="component-error-text"
                  >
                    {errorMsg}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>

            <Grid item>
              <Typography
                className={classes.formlabel1}
                style={{ paddingTop: "10px" }}
              >
                Sip Id
              </Typography>
              <FormControl>
                <TextField
                  value={sipGroupId}
                  placeholder="Enter Sip Id"
                  InputProps={{
                    style: {
                      width: "342px ",
                      height: "42px ",
                      backgroundColor: "white",
                      flexShrink: 0,
                      color: "black",
                      fontFamily: "cardiuma-regular",
                      fontSize: "12px",
                      fontStyle: "normal",
                      fontWeight: "400",
                      lineHeight: "20px",
                    },
                  }}
                  onChange={(e) => {
                    setSipGroupId(e.target.value);
                    setErrType(0);
                  }}
                />
                {errType === 3 && (
                  <FormHelperText
                    className={classes.errtxt}
                    id="component-error-text"
                  >
                    {errorMsg}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Button
              style={{
                backgroundColor: "#F3D45E",
                width: "136px",
                height: "42px",
                marginLeft: "90px",
                marginTop: "30px",
              }}
              onClick={editDepartment ? EditDepartment : CreateNewDepartment}
            >
              <span style={{ color: "#3E3E3E", textTransform: "none" }}>
                Save
              </span>
            </Button>
          </Grid>
        </div>
      </Modal>
      <div
        className={classes.horizantalTablayout}
      >
        <TableContainer>
          <Table sx={{ minWidth: 30 }} aria-label="simple table">
            <TableHead>
              <TableRow style={{ borderBottom: "2px solid Black" }}>
                {/* Srini - 12/11/24  */}
                <TableCell className={classes.tableHeading1} align="left">
                  SIP_ID
                </TableCell>
                <TableCell className={classes.tableHeading2} align="left">
                  Name
                </TableCell>
                <TableCell className={classes.tableHeading2} align="left">
                  Description
                </TableCell>
                <TableCell className={classes.tableHeading3} align="left">
                  Action
                </TableCell>
                {/* {<TableCell className={classes.tableHeading3} align="start">
                  Config
                </TableCell>} */}
              </TableRow>
            </TableHead>
            <TableBody>
              {/* added by srini on 16-01-25 */}
              {departmentData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                <TableRow
                  key={index}
                  style={{ borderBottom: "2px solid Black" }}
                >
                  {/* Srini - 12/11/24  */}
                  <TableCell align="left" className={classes.rowText}>
                    {item.sip_group_id}
                  </TableCell>
                  <TableCell align="left" className={classes.rowText}>
                    {item.name}
                  </TableCell>
                  <TableCell align="left" className={classes.rowText}>
                    {item.description}
                  </TableCell>
                  <TableCell align="left">
                    <IconButton onClick={() => editDepartmentModal(item)}>
                      <EditIcon
                        style={{ color: "#0083CA", fontSize: "18px" }}
                      />
                    </IconButton>
                  </TableCell>
                  {/* {<TableCell align="start">
                    <IconButton>
                      <SettingsIcon
                        style={{ color: "#0083CA", fontSize: "18px" }}
                      />
                    </IconButton>
                  </TableCell>} */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {/* added by srini on 16-01-25 */}
        <TablePagination
          className={classes.pagination}
          rowsPerPageOptions={[10, 15, 20]}
          component="div"
          count={departmentData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(Department);
